// @flow
import React, { Component } from 'react';
import { ToggleArrowDiv } from './SidebarStyles';
import { DefaultIcon } from '../../../components/Icon';

type Props = {
  toggleSidebar: () => void,
  sidebarOpened: boolean
};

export default class SidebarArrow extends Component<Props> {
  render() {
    return (
      <>
        <ToggleArrowDiv onClick={this.props.toggleSidebar}>
          <DefaultIcon
            name={this.props.sidebarOpened ? 'arrowLeftO' : 'arrowRightO'}
          />
        </ToggleArrowDiv>
      </>
    );
  }
}
